import { Injectable } from '@angular/core';
import { Howl, Howler } from 'howler';
import { radiosUrl } from './radios-url';
import { BehaviorSubject } from 'rxjs';
import { AnalitycsService } from './analitycs.service';

@Injectable({
  providedIn: 'root'
})
export class RadiosDataService {
  RADIOAM247=false;
  RADIOFM961=true;
  RADIOUNIVERSAL=false;
  PLAYLISTONOFF=false;


  cenFM = new Howl({
    src: ['https://radio.yoemito.net/listen/centroam/stream'],
    html5: true,
    volume:0.3

  });
  cenAM = new Howl({
    src: ['https://radio.yoemito.net/listen/centrofm/stream'],
    html5: true,
    volume:0.2
  });
  universal = new Howl({
    src: ['https://radio.yoemito.net/listen/universalfm/stream'],
    html5: true,
    volume:0.3
  });


  playCenAM = false;
  playCenFM = false;
  playUniversal = false;

  uniPlay;
  amPlay;
  fmPlay;

  getDOMAudio:any;
  playing:BehaviorSubject<number> = new BehaviorSubject(0);
  constructor(private analytics: AnalitycsService) {


  }

  getPlayer(){
    return this.playing.asObservable();
  }

  public playradioUniversal(): void {
    this.analytics.logEvents("playradioUniversal");
    this.amPlay = this.cenAM.stop();
    this.fmPlay = this.cenFM.stop();
    this.getDOMAudio=document.getElementById('audioaux');
    this.getDOMAudio.src=radiosUrl[2].url;
    this.playing.next(0);
    this.getDOMAudio.play();
  }


  public playCentroAM(): void {
    this.analytics.logEvents("playCentroAM");
    this.uniPlay = this.universal.stop();
    this.amPlay = this.cenAM.stop();
    this.getDOMAudio=document.getElementById('audioaux');
    this.getDOMAudio.src=radiosUrl[1].url;
    this.playing.next(1);
    this.getDOMAudio.play();
  }

  public playCentroFM(): void {
    this.analytics.logEvents("playCentroFM");
    this.uniPlay = this.universal.stop();
    this.fmPlay = this.cenFM.stop();
    this.getDOMAudio=document.getElementById('audioaux');
    this.getDOMAudio.src=radiosUrl[0].url;
    this.playing.next(2);
    this.getDOMAudio.play();
  }

  public pause(): void {
    this.analytics.logEvents("pauseradio");
    this.uniPlay = this.universal.stop();
    this.fmPlay = this.cenAM.stop();
    this.amPlay = this.cenFM.stop();
    this.getDOMAudio=document.getElementById('audioaux');
    if(this.getDOMAudio!=undefined)
    {
      this.getDOMAudio.pause();
      this.getDOMAudio.src="";
      this.RADIOAM247=false;
      this.RADIOFM961=true;
      this.RADIOUNIVERSAL=false;
    }
    else{
      console.log("error");
    }
  }



   setRadioCenAM(value) {
    this.playCenAM = value;
  }

  setRadioCenFM(value) {
    this.playCenFM = value;
  }

  setRadioUniversal(value) {
    this.playUniversal = value;
  }

  getRadioCenAM() {
    return this.playCenAM;
  }

  getRadioCenFM() {
    return this.playCenFM;
  }

  getRadioUniversal() {
    return this.playUniversal;
  }

  isPlayingAM(){
    return this.cenAM.playing(this.amPlay);
  }

  isPlayingFM(){
    return this.cenFM.playing(this.fmPlay);
  }

  isPlayingUniversal(){
    return this.universal.playing(this.uniPlay);
  }

}
